
Blain.OrderTracking = {

	init() {
		Blain.OrderTracking.initForm();
		Blain.OrderTracking.initSearch();
	},

	initForm() {
		const $form = $('#trackOrderForm');
		if (!$form.length) return;

		$form.validate({
			rules: {
				email: {
					required: true,
					email: true
				},
				oid: {
					required: true,
					number: true
				}
			}
		});
	},

	initSearch() {
		const $btn = $("#searchOrdersButton");
		if (!$btn.length) return;
		const loadingHtml = `<span><i class="fa fa-cog fa-spin"></i> Searching...</span>`;
		$btn.on('click', () => {
			$btn.html(loadingHtml);
		});
	}
};